import VotingForm from 'polls/modules/voting-formV2';
import EntryComments from 'polls/modules/entry-comments';
import EntryRatingUI from 'entry/ui/rating';
import VoteDescriptionSlider from 'polls/modules/vote-description-slider';
import PollEntryModalUI from 'polls/modules/polls-entry-modal';

document.addEventListener('DOMContentLoaded', () => {
    VotingForm.attachTo('#votingform');
    EntryComments.attachTo('[data-entry-comment]');
    EntryRatingUI.attachTo('[data-entry-rater]', {
        url: 'data-entry-rater-path',
    });
    VoteDescriptionSlider.attachTo('[data-description-slider]');
    PollEntryModalUI.attachTo('body');
});



// WEBPACK FOOTER //
// ./src/web/js/polls/vote.js